import posthog, { Properties } from 'posthog-js';
import { PosthogFeatureFlag } from 'shared/constants/posthog';

const POSTHOC_TOKEN = 'phc_CgYqjsvT0vZ9HExF9yPr4as90bD7WeaNgHEGRhJL8e7';
const POSTHOC_API_HOST = 'https://us.posthog.com';

const MARKETING_ATTRIBUTES_TO_NOT_OVERWRITE_AT_IDENTIFY = {
  $initial_utm_source: null,
  $initial_utm_medium: null,
  $initial_utm_campaign: null,
  $initial_utm_content: null,
  $initial_utm_term: null,
  $initial_referring_domain: null,
  $initial_referrer: null,
  $referrer: null,
  $referring_domain: null
} as const;

export enum PosthogEvent {
  // Error events
  ERROR_ALERT_DISPLAYED = 'error:alert_displayed',
  ERROR_CHAT_MESSAGE_HANDLING = 'error:chat_message_handling',

  // Smart assistant events
  SMART_ASSISTANT_CREATED = 'smart_assistant:created',
  SMART_ASSISTANT_MESSAGE_SENT = 'smart_assistant:message_sent',

  // Resource events
  RESOURCE_CREATED = 'resource:created',

  // Subscription events
  SUBSCRIPTION_TRIAL_BILLING_SESSION_OPENED = 'subscription:trial_billing_session_opened',
  SUBSCRIPTION_BILLING_SESSION_OPENED = 'subscription:billing_session_opened',
  SUBSCRIPTION_CANCELLED = 'subscription:cancelled',
  SUBSCRIPTION_REACTIVATED = 'subscription:reactivated',
  SUBSCRIPTION_CHURN_DISCOUNT_CLAIMED = 'subscription:churn_discount_claimed'
}

export const PosthogService = {
  init: () => {
    posthog.init(POSTHOC_TOKEN, {
      api_host: POSTHOC_API_HOST,
      session_recording: {
        maskAllInputs: false,
        maskInputOptions: {
          password: true,
          color: false,
          date: false,
          'datetime-local': false,
          email: false,
          month: false,
          number: false,
          range: false,
          search: false,
          tel: false,
          text: false,
          time: false,
          url: false,
          week: false,
          textarea: false,
          select: false
        }
      }
    });

    posthog.register_once(MARKETING_ATTRIBUTES_TO_NOT_OVERWRITE_AT_IDENTIFY);
  },
  identify: (email?: string, properties?: Properties, setOnceProperties?: Properties) => {
    // If email is not provided, use the distinct_id instead. This probably means the user is not authenticated (guest user).
    posthog.identify(
      email ? email : posthog.get_distinct_id(),
      {
        ...properties
      },
      {
        ...setOnceProperties
      }
    );
  },
  isFeatureFlagEnabled: (featureFlag: PosthogFeatureFlag) => {
    return !!posthog.isFeatureEnabled(featureFlag);
  },
  capture: (event: PosthogEvent, properties?: Properties) => {
    posthog.capture(event, properties);
  }
};
